// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetSmsSettingsResponse

export type WidgetSmsSettingsApiResponse = {
	shortBusinessName: string | null;
};

export type WidgetSmsSettings = {
	shortBusinessName: string | null;
};

export function hydrateWidgetSmsSettings(data: WidgetSmsSettingsApiResponse): WidgetSmsSettings {
	return { ...data };
}